<template>
  <div>
    <common-dialog
      ref="dialog"
      width="1000px"
      title="详情 信息通告"
      id-key="ArticleId"
      :data="data"
      @details-opened="onDetailsOpened"
    >
      <template slot="form">
        <el-row>
          <el-col :span="$store.state.isMB?24:22">
            <el-form-item label="标题" prop="Title">
              <span>{{data.Title}}</span>
            </el-form-item>
          </el-col>
          <el-col v-if="$store.state.isMB" :span="24">
            <el-form-item label="置顶">
              <span>{{data.IsTop?'是':'否'}}</span>
            </el-form-item>
          </el-col>
          <el-col v-else :span="2">
            <el-form-item label-width="0px">
              <span style="margin: 0px 15px;">置顶</span>
              <span>{{data.IsTop?'是':'否'}}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="$store.state.isMB?24:12">
            <el-form-item label="发布人" prop="Publisher">
              <span>{{data.Publisher}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="$store.state.isMB?24:12">
            <el-form-item label="发布时间">
              <span>{{data.PublishTime}}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="信息来源" prop="Source">
              <span>{{data.Source}}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-divider>信息通告内容</el-divider>
        <el-row>
          <el-col :span="24">
            <div class="a-content" v-html="data.Content"></div>
          </el-col>
        </el-row>
      </template>
      <template slot="footer">
        <!-- <el-button size="mini" type="info" style="float:left" @click="checkLog">审核日志</el-button>
        <template v-if="!isDetail">
          <el-button size="mini" type="primary" @click="pass">通 过</el-button>
          <el-button size="mini" type="danger" @click="back">退 回</el-button>
        </template>-->
        <el-button size="mini" @click="close">关 闭</el-button>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      data: {
        ArticleId: 0,
        Title: "",
        ColumnId: 1,
        Content: "",
        ContentText: "",
        Source: "",
        Publisher: "",
        PublishTime: null,
        IsTop: false,
        Sort: 0,
      },
    };
  },
  computed: {},
  methods: {
    onDetailsOpened(data) {
      $(".a-content")
        .find("img")
        .each(function () {
          let wWidth = $(".a-content").width();
          let pWidth = $(this).width();
          if (pWidth > wWidth) {
            $(this).css("width", "100%");
            $(this).css("height", "100%");
          }
        });
    },
  },
};
</script>